import { motion } from 'framer-motion';

export const SectionLabel = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-brand-cyan/90 font-medium font-mono">
    <span className="h-px w-8 bg-brand-cyan/60" />
    {children}
  </span>
);

export const SectionTitle = ({ label, title, subtitle, align = 'left' }) => (
  <div className={`mb-12 ${align === 'center' ? 'text-center mx-auto max-w-3xl' : ''}`}>
    {label && <SectionLabel>{label}</SectionLabel>}
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black mt-4 tracking-tight">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-base sm:text-lg text-brand-ink leading-relaxed max-w-2xl">
        {align === 'center' ? <span className="mx-auto block">{subtitle}</span> : subtitle}
      </p>
    )}
  </div>
);

export const FadeIn = ({ children, delay = 0, y = 24, className = '' }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default SectionTitle;
